import React from 'react';
import PropTypes from 'prop-types';
import radioLabelLeft from './radioLabelLeft.scss';
import radioLabelRight from './radioLabelRight.scss';

class SunbitRadioGroup extends React.Component {

  static propTypes = {
    children: PropTypes.node,
    value: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    childLabelPosition: PropTypes.string,
    childTheme: PropTypes.string,
  };

  handleChange(value) {
    if (this.props.onChange) this.props.onChange(value);
  }

  resolveChildTheme(child) {
    let theme = {};
    if (this.props.childLabelPosition === 'left') {
      theme = {...radioLabelLeft};
    }
    else {
      theme = {...radioLabelRight};
    }
    if (this.props.childTheme) {
      theme = {...theme, ...this.props.childTheme};
    }
    if (child.props.theme) {
      theme = {...theme, ...child.props.theme};
    }

    return theme;
  }

  renderRadioButtons() {
    return React.Children.map(this.props.children, child => {

      return React.cloneElement(child, {
        theme: this.resolveChildTheme(child),
        checked: child.props.value === this.props.value,
        disabled: this.props.disabled || child.props.disabled,
        onChange: this.handleChange.bind(this, child.props.value)
      });

    });
  }

  render() {
    return (
      <div data-react-toolbox="radio-group" className={this.props.className}>
        {this.renderRadioButtons()}
      </div>
    );
  }
}

export default SunbitRadioGroup;



// WEBPACK FOOTER //
// ./src/components/common/material/RadioGroup.js